import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ClubbieButton from "../../components/ClubbieButton/ClubbieButton";
import { updateTournament } from "../../redux/slices/tournamentSlice";
import { fixedValues } from "../../utils/fixedValues";
import { DASHBOARD_STACK } from "../../utils/screenNames";
import { tournamentWizardStepCompleted } from "../../utils/analytics";
import { WIZARD_STEP } from "../../utils/analyticsEvents";

import "./ChooseTournament.css";

const ChooseDurationType = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  const [selectedDurationType, setSelectedDurationType] = useState(
    selectedTournament?.durationType || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedTournament?.durationType) {
      setSelectedDurationType(selectedTournament.durationType);
    }
  }, [selectedTournament]);

  const handleNext = async () => {
    try {
      setIsLoading(true);
      if (!selectedDurationType) {
        toast.error("Please select a tournament type");
        return;
      }

      let updateData = {
        durationType: selectedDurationType,
      };

      const result = await dispatch(
        updateTournament({
          id: selectedTournament?.id,
          updateData,
        })
      ).unwrap();

      if (result) {
        tournamentWizardStepCompleted({
          stepName: WIZARD_STEP.CHOOSE_DURATION_TYPE,
          tournamentId: selectedTournament?.id,
        });
        toast.success("Tournament duration type updated successfully!");
        navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.CHOOSE_VENUE_TYPE);
      } else {
        throw new Error("Failed to update tournament duration type");
      }
    } catch (error) {
      toast.error(error.message || "Failed to update tournament duration type");
    } finally {
      setIsLoading(false);
    }
  };

  const tournaments = [
    {
      id: fixedValues.durationTypes.SINGEL_DAY_TOURNAMENT,
      name: fixedValues.durationTypes.SINGEL_DAY_TOURNAMENT_LABEL,
    },
    {
      id: fixedValues.durationTypes.LONG_TERM_TOURNAMENT,
      name: fixedValues.durationTypes.LONG_TERM_TOURNAMENT_LABEL,
    },
  ];

  return (
    <>
      <div className="input-section">
        <p>Choose Duration Type</p>
        <div className="tournaments-container">
          {tournaments.map((tournament) => (
            <button
              key={tournament.id}
              className={`tournament-option ${
                selectedDurationType === tournament.id ? "selected" : ""
              }`}
              onClick={() => setSelectedDurationType(tournament.id)}
              type="button"
            >
              <div className="tournament-radio" />
              <span className="tournament-name">{tournament.name}</span>
            </button>
          ))}
        </div>
      </div>

      <ClubbieButton
        className="next-button"
        onClick={handleNext}
        disabled={isLoading || !selectedDurationType}
        isLoading={isLoading}
      >
        Next
      </ClubbieButton>
    </>
  );
};

export default ChooseDurationType;
